import { MarkupItemType } from '@/lib/markup-designer/models';

export const basePrimitive = (
    feature: any,
    type: MarkupItemType,
    stroke?: any,
    fill?: any
) => ({
    id: feature.id,
    name: feature.name,
    type,
    isVisible: true,
    isLocked: false,
    displayProps: { geometry: feature.geometry },
    dataProps: { ...feature.properties, type, isLocked: false, stroke, fill },
});
